<template>
  <div
    :class="{ 'no-clickable': disabled, 'no-draggable': disabled && isDragging, 'drag-active': isDragging }"
    class="drag-area"
    @click="selectFiles"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
  >
    <slot>
      <div class="empty-content">
        <p class="md-display-1">Click para seleccionar o arrastre los archivos</p>
      </div>
    </slot>
    <input multiple name="file" type="file" class="file" ref="fileInput" @change="onFileSelect" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, null],
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    exe: {
      type: [Function, Boolean],
      required: false,
    },
    allowedFormats: {
      type: Array,
      reuired: false,
      default: () => [],
    },
  },
  data() {
    return {
      isDragging: false,
    };
  },

  methods: {
    selectFiles() {
      if (this.disabled) return;
      if (!!this.exe) {
        this.exe();
        return;
      }
      this.$refs.fileInput.click();
    },
    onFileSelect(e) {
      const files = e.target.files;
      if (files.length === 0 || this.disabled) return;
      const filteredFiles = Object.values(files).filter(({ name }) => {
        const format = name.split(".").pop();
        return this.allowedFormats.length
          ? this.allowedFormats.includes(format.toLowerCase())
          : true;
      });
      this.$emit(
        "input",
        !!this.value ? [...this.value, ...filteredFiles] : filteredFiles
      );
      this.$refs.fileInput.value = "";
    },
    onDragOver(e) {
      e.preventDefault();
      this.isDragging = true;
      e.dataTransfer.dropEffect = "copy";
    },
    onDragLeave(e) {
      e.preventDefault();
      this.isDragging = false;
    },
    onDrop(e) {
      e.preventDefault();
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length === 0 || this.disabled) return;
      const filteredFiles = Object.values(files).filter(({ name }) => {
        const format = name.split(".").pop();
        return this.allowedFormats.length
          ? this.allowedFormats.includes(format.toLowerCase())
          : true;
      });
      this.$emit(
        "input",
        !!this.value ? [...this.value, ...filteredFiles] : filteredFiles
      );
    },
  },
};
</script>

<style lang="less" scoped>
.drag-area {
  min-height: 100px;
  width: 100%;
  border-radius: 5px;
  // border: 2px dashed #fe0000;
  background: #f4f3f9;
  color: #fe0000;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: center;
  cursor: pointer;
  border: 2px dashed #0000001b;
  -webkit-user-select: none;
}

.no-clickable {
  cursor: default;
  background-color: unset !important;
  border: unset !important;
}
.no-draggable {
  border: unset !important;
}

.drag-active {
  border: 2px dashed #00ff2a;
  background: #a0a0a0;
}

.drag-area .visible {
  font-size: 18px;
}

.select {
  color: #5256ad;
  margin-left: 5px;
  cursor: pointer;
  transition: 0.4s;
}

.select:hover {
  opacity: 0.6;
}

input,
.drag-area .on-drop,
.drag-area.dragover .visible {
  display: none;
}

.drag-area .on-drop,
.drag-area.dragover .visible {
  border: 2px dashed #00ff66;
}
.drag-area:hover {
  background: #dfdfdf;
}

.empty-content {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100%;
}

.file {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Inputs/KDraggableField.vue